import React, { useEffect } from 'react'
import {
  BlockStack,
  Box,
  Button,
  Checkbox,
  Divider,
  Form,
  FormLayout,
  InlineError,
  InlineStack,
  Select,
  Text,
  TextField,
} from '@shopify/polaris'
import { useTranslation } from 'react-i18next'

import CodeEditor from '../../../../../components/CodeEditor'

function AdvancedSection({ form }) {
  const { t } = useTranslation()

  const storeData = JSON.parse(form.fields.storeData.value)
  const storeDataHandler = (path, value) => {
    if (value === '') return
    const updatedStoreData = { ...storeData }
    const pathParts = path.split('.')
    let current = updatedStoreData

    // Traverse the path and create objects if they don't exist
    for (let i = 0; i < pathParts.length - 1; i++) {
      const part = pathParts[i]
      if (!current[part]) {
        current[part] = {}
      }
      current = current[part]
    }

    // Set the value at the final path
    current[pathParts[pathParts.length - 1]] = value

    // Update the form field with the new store data
    form.fields.storeData.onChange(JSON.stringify(updatedStoreData, null, 2))
  }

  return (
    <Form onSubmit={form.submit}>
      <Box padding={'0'}>
        <BlockStack gap={'300'}>
          {form.fields.storeData.error && (
            <InlineError message={form.fields.storeData.error} />
          )}
          <Box padding={'0'}>
            <BlockStack gap={'100'}>
              <Text as="strong">
                {t(
                  'SettingsPage.Sections.Advanced.Section.advanced.Settings.title',
                )}
              </Text>
              <Checkbox
                label={t(
                  'SettingsPage.Sections.Advanced.Section.advanced.Settings.Form.label',
                )}
                helpText={t(
                  'SettingsPage.Sections.Advanced.Section.advanced.Settings.Form.helpText',
                )}
                {...form.fields.skipParentProduct}
              />
            </BlockStack>
          </Box>
          <Divider />
          <BlockStack gap={'300'}>
            <Box paddingBlockStart={'300'}>
              <BlockStack gap={'300'}>
                <Text as="strong">
                  {t(
                    'SettingsPage.Sections.Advanced.Section.advanced.StoreData.title',
                  )}
                </Text>
                <CodeEditor
                  mode={'json'}
                  value={form.fields.storeData.value}
                  onChange={form.fields.storeData.onChange}
                  height={'500px'}
                  readOnly={form.submitting}
                />
              </BlockStack>
            </Box>
            <InlineStack align="end">
              <Button loading={form.submitting} submit>
                {t('SettingsPage.Sections.Advanced.Section.advanced.btnCta')}
              </Button>
            </InlineStack>
          </BlockStack>
        </BlockStack>
      </Box>
    </Form>
  )
}

export default AdvancedSection

const getChatModelOptions = (t, storeData) =>
  [
    {
      label: '-',
      value: '',
    },
    {
      label: t(
        'SettingsPage.Sections.Advanced.Section.advanced.StoreData.enrichment.chatModel.options.gpt-4o-mini',
      ),
      value: 'gpt-4o-mini',
    },
  ].filter(({ value }) => {
    if (!storeData?.enrichments?.chatModel) return true
    return value !== ''
  })

const getEmbeddingModelOptions = (t, storeData) =>
  [
    {
      label: '-',
      value: '',
    },
    {
      label: t(
        'SettingsPage.Sections.Advanced.Section.advanced.StoreData.enrichment.embeddingModel.options.text-embedding-3-small',
      ),
      value: 'text-embedding-3-small',
    },
  ].filter(({ value }) => {
    if (!storeData?.enrichments?.embeddingModel) return true
    return value !== ''
  })

const embeddingModelDimensionsMapping = {
  'text-embedding-3-small': 1536,
}
